/* Dormille — tiroir de panier
   ---------------------------------------------------------------------------
   Le tiroir est rendu par sections/cart-drawer.liquid, present sur toutes les
   pages. Ce fichier ne construit aucun HTML : il rejoue la section par l API
   de rendu de section de Shopify. Le prix, le total et les libelles restent
   donc toujours formates par Shopify.

   L etat ouvert vit sur <html class="dw-open">, jamais dans le tiroir :
   remplacer le contenu ne referme donc pas le panier.

   Sans JavaScript, rien n est casse : les liens panier menent a /cart et les
   formulaires d ajout font un envoi classique.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var CONTENEUR = 'shopify-section-cart-drawer';
  var racine = document.documentElement;

  function tiroir()  { return document.getElementById(CONTENEUR); }
  function panneau() { return document.querySelector('[data-drawer] .dw__panel'); }

  /* ---- le format monetaire de Shopify contient des entites HTML ---- */
  var decodeur = document.createElement('textarea');
  function decode(t) { decodeur.innerHTML = t || ''; return decodeur.value; }

  /* ---- ouverture / fermeture ---- */
  var dernierFocus = null;

  function ouvrir() {
    if (!tiroir()) return;
    dernierFocus = document.activeElement;
    racine.classList.add('dw-open');
    var p = panneau();
    if (p) { p.focus(); }
  }

  function fermer() {
    racine.classList.remove('dw-open');
    if (dernierFocus && dernierFocus.focus) { dernierFocus.focus(); }
  }

  // Un voile d attente qui ne se leve pas donne un tiroir fige : le garde-fou
  // le retire au bout de 8 secondes, quoi qu il arrive au reseau.
  var minuteur = null;

  function occupe(actif) {
    var b = document.querySelector('[data-drawer-busy]');
    if (b) { b.hidden = !actif; }

    if (minuteur) { clearTimeout(minuteur); minuteur = null; }
    if (actif) {
      minuteur = setTimeout(function () {
        var e = document.querySelector('[data-drawer-busy]');
        if (e) { e.hidden = true; }
      }, 8000);
    }
  }

  // Le tiroir ne doit jamais quitter la page de lui-meme : une navigation
  // declenchee par une erreur reseau se lit comme « la page charge sans fin ».
  function echec(ou, err) {
    occupe(false);
    if (window.console) { console.warn('[Dormille] tiroir : ' + ou, err); }
  }

  /* ---- rafraichissement par l API de rendu de section ---- */
  function rafraichir() {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neuf = doc.getElementById(CONTENEUR) || doc.body;
        var cible = tiroir();
        if (cible) { cible.innerHTML = neuf.innerHTML; }

        // le compteur de l en-tete suit le tiroir
        var n = document.querySelector('.dw__count');
        document.querySelectorAll('[data-cart-count]').forEach(function (e) {
          if (n) { e.textContent = n.textContent.trim(); }
        });
      });
  }

  /* ---- appels panier ---- */

  // On adresse la ligne par sa cle, pas par son rang : le rang se decale des
  // qu une ligne disparait, et un rang perime fait echouer /cart/change.js.
  function changerLigne(cle, quantite) {
    occupe(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: cle, quantity: quantite })
    })
      .then(function (r) {
        if (!r.ok) { throw new Error('change.js ' + r.status); }
        return rafraichir();
      })
      .then(function () { occupe(false); })
      .catch(function (e) { echec('changement de quantite', e); });
  }

  function ajouter(corps) {
    occupe(true);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: corps })
      .then(function (r) {
        if (!r.ok) { throw new Error('ajout refuse'); }
        return r.json();
      })
      .then(rafraichir)
      .then(function () { occupe(false); ouvrir(); });
  }

  /* ---- derniere proposition avant le paiement ---- */

  var CLE_REFUS = 'dormille-upsell-refuse';

  function refuse() {
    try { return sessionStorage.getItem(CLE_REFUS) === '1'; } catch (err) { return false; }
  }
  function noterRefus() {
    try { sessionStorage.setItem(CLE_REFUS, '1'); } catch (err) { /* navigation privee */ }
  }

  function versPaiement() { window.location.href = '/checkout'; }

  // Renvoie true si la proposition a ete affichee, false s il faut laisser
  // le paiement suivre son cours.
  function proposer() {
    if (refuse()) return false;
    var boite = document.querySelector('[data-upsell]');
    if (!boite) return false;

    boite.hidden = false;
    racine.classList.add('dw-up-open');
    var d = boite.querySelector('.dw-up__box');
    if (d) { d.focus(); }
    return true;
  }

  // Les housses gardees : toutes, sauf celles dont la case a ete decochee.
  function lignesGardees(boite) {
    return [].filter.call(boite.querySelectorAll('[data-upsell-ligne]'), function (l) {
      var c = l.querySelector('[data-upsell-garde]');
      return !c || c.checked;
    });
  }

  // Remet le bouton, le prix et le total d accord avec les housses gardees.
  // Les montants viennent tous des paliers calcules par Shopify.
  function majSelection(boite) {
    var gardees = lignesGardees(boite);
    var brut = boite.querySelector('[data-upsell-paliers]');
    if (brut) {
      var p = JSON.parse(brut.textContent)[gardees.length];
      var champs = { libelle: p.libelle, housses: p.housses, somme: p.total, unite: p.unite };
      Object.keys(champs).forEach(function (k) {
        var e = boite.querySelector('[data-upsell-' + k + ']');
        if (e) { e.textContent = decode(champs[k]); }
      });
      var u = boite.querySelector('[data-upsell-unite]');
      if (u) { u.hidden = gardees.length < 2; }
    }
    var bouton = boite.querySelector('[data-upsell-add]');
    bouton.disabled = gardees.length === 0 || gardees.some(function (l) {
      return l.getAttribute('data-dispo') === 'false';
    });
  }

  function fermerProposition() {
    var boite = document.querySelector('[data-upsell]');
    if (boite) { boite.hidden = true; }
    racine.classList.remove('dw-up-open');
  }

  /* ---- clics ---- */
  document.addEventListener('click', function (e) {

    // « Commander » : on intercale la proposition, une seule fois par visite.
    var paiement = e.target.closest('[data-drawer-checkout], button[name="checkout"]');
    if (paiement && proposer()) {
      e.preventDefault();
      return;
    }

    // la croix et le voile referment, sans emmener nulle part
    if (e.target.closest('[data-upsell-close]')) {
      e.preventDefault();
      noterRefus();
      fermerProposition();
      return;
    }

    // seul ce bouton part au paiement
    if (e.target.closest('[data-upsell-skip]')) {
      e.preventDefault();
      noterRefus();
      fermerProposition();
      versPaiement();
      return;
    }

    // une housse par oreiller garde : les lignes de meme variante sont regroupees
    var ajoutUp = e.target.closest('[data-upsell-add]');
    if (ajoutUp) {
      e.preventDefault();
      var parId = {};
      var ordre = [];
      lignesGardees(ajoutUp.closest('[data-upsell]')).forEach(function (l) {
        var id = l.getAttribute('data-variant');
        if (!parId[id]) { parId[id] = 0; ordre.push(id); }
        parId[id] += 1;
      });
      var items = ordre.map(function (id) { return { id: Number(id), quantity: parId[id] }; });
      ajoutUp.disabled = true;
      occupe(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) { throw new Error('add.js ' + r.status); }
          versPaiement();
        })
        .catch(function (err) {
          ajoutUp.disabled = false;
          echec('ajout de la derniere proposition', err);
          versPaiement(); // on ne bloque jamais un client qui veut payer
        });
      return;
    }


    // tout lien vers le panier ouvre le tiroir, sauf clic milieu ou modificateur.
    // [data-drawer-full] est le lien « voir le panier en entier » du tiroir :
    // lui doit vraiment naviguer.
    var lien = e.target.closest('a[href$="/cart"], a[href$="/cart/"], .cart-link');
    if (lien && lien.hasAttribute('data-drawer-full')) { return; }
    if (lien && tiroir() && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      e.preventDefault();
      ouvrir();
      return;
    }

    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); fermer(); return; }

    var pas = e.target.closest('[data-line-step]');
    if (pas) {
      var l = pas.closest('[data-line]');
      var n = parseInt(l.querySelector('.dw-stepper__n').textContent, 10);
      var suivant = n + parseInt(pas.getAttribute('data-line-step'), 10);
      changerLigne(l.getAttribute('data-key'), Math.max(0, suivant));
      return;
    }

    var retrait = e.target.closest('[data-line-remove]');
    if (retrait) {
      changerLigne(retrait.closest('[data-line]').getAttribute('data-key'), 0);
      return;
    }

    var ajout = e.target.closest('[data-sugg-add]');
    if (ajout) {
      var corps = new FormData();
      corps.append('id', ajout.getAttribute('data-variant'));
      corps.append('quantity', '1');
      ajout.disabled = true;
      ajouter(corps).catch(function (err) {
        ajout.disabled = false;
        echec('ajout de la suggestion', err);
      });
      return;
    }
  });

  /* ---- choix d une variante dans la derniere proposition ---- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-upsell-value]')) return;

    var boite = e.target.closest('[data-upsell]');
    var ligne = e.target.closest('[data-upsell-ligne]');
    var grp = e.target.closest('.chooser');
    grp.querySelectorAll('.chooser__opt').forEach(function (o) {
      o.classList.toggle('is-on', o.contains(e.target));
    });

    // une ligne = une housse ; sa taille peut etre fixee par celle de l oreiller
    var vals = [];
    ligne.querySelectorAll('[data-upsell-option]').forEach(function (g) {
      var c = g.querySelector('[data-upsell-value]:checked');
      vals[Number(g.getAttribute('data-upsell-option'))] = c ? c.value : null;
    });
    ligne.querySelectorAll('[data-upsell-fixed]').forEach(function (h) {
      vals[Number(h.getAttribute('data-upsell-fixed'))] = h.value;
    });

    var liste = JSON.parse(boite.querySelector('[data-upsell-variants]').textContent);
    var v = liste.find(function (x) {
      return x.options.every(function (o, i) { return o === vals[i]; });
    });
    if (!v) return;

    ligne.setAttribute('data-variant', v.id);
    ligne.setAttribute('data-dispo', v.dispo ? 'true' : 'false');

    var prix = ligne.querySelector('[data-upsell-prix]');
    if (prix) { prix.textContent = decode(v.prix); }
    var total = boite.querySelector('[data-upsell-total]');
    if (total) { total.textContent = decode(v.total); }

    majSelection(boite);
  });

  /* ---- garder ou retirer une housse de la derniere proposition ---- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-upsell-garde]')) return;
    e.target.closest('[data-upsell-ligne]').classList.toggle('is-off', !e.target.checked);
    majSelection(e.target.closest('[data-upsell]'));
  });

  /* ---- choix d une variante dans une suggestion ---- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sugg-value]')) return;

    var carte = e.target.closest('[data-sugg]');
    var groupe = e.target.closest('.chooser');
    groupe.querySelectorAll('.chooser__opt').forEach(function (o) {
      o.classList.toggle('is-on', o.contains(e.target));
    });

    var choisies = [].map.call(carte.querySelectorAll('[data-sugg-option]'), function (g) {
      var coche = g.querySelector('[data-sugg-value]:checked');
      return coche ? coche.value : null;
    });

    var brut = carte.querySelector('[data-sugg-variants]');
    if (!brut) return;
    var variantes = JSON.parse(brut.textContent);
    var v = variantes.find(function (x) {
      return x.options.every(function (o, i) { return o === choisies[i]; });
    });
    if (!v) return;

    var bouton = carte.querySelector('[data-sugg-add]');
    var prix = carte.querySelector('[data-sugg-price]');
    bouton.setAttribute('data-variant', v.id);
    bouton.disabled = !v.dispo;
    if (prix) { prix.textContent = '+ ' + decode(v.prix); }
  });

  /* ---- ajout au panier depuis une fiche produit ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action$="/cart/add"]')) return;
    if (!tiroir()) return;

    e.preventDefault();

    // FormData ignore les champs desactives : seules les proprietes du palier
    // selectionne partent, exactement comme lors d un envoi classique.
    ajouter(new FormData(form)).catch(function (err) {
      echec('ajout au panier', err);
      form.submit(); // repli : envoi classique, Shopify affichera l erreur
    });
  });

  /* ---- clavier ---- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    // La proposition passe avant le tiroir : c est elle qui est au-dessus.
    if (racine.classList.contains('dw-up-open')) {
      noterRefus();
      fermerProposition();
      return;
    }
    if (racine.classList.contains('dw-open')) { fermer(); }
  });
})();
